var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5495",
    "data-name": "Group 5495",
    transform: "translate(-1328 -316)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "plus_line_2",
    "data-name": "plus line 2",
    y2: 10,
    transform: "translate(1333 316)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "plus_line_1",
    "data-name": "plus line 1",
    y2: 10,
    transform: "translate(1338 321) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePlus);
export default __webpack_public_path__ + "static/media/mobile-plus.5ae7e96465fb58ff6fc52468e990494d.svg";
export { ForwardRef as ReactComponent };